// extracted by mini-css-extract-plugin
export default {"summary":"liJTjl2_jrs_ZbUE0vrr","stat":"VePjzA4r_r4KFbz9N9K1","sep":"zLzXNnwXPfYVSJaXuKh2"};